<template>
  <div class="lemmaDetails">
    <div v-if="loading || !lemma">
      Loading..
    </div>
    <article v-else>
      <b-row>
        <b-col v-if="!hideTitle">
          <h3 class="mb-4" v-html="lemmaDisplay"></h3>
        </b-col>
        <b-col class="mt-1 text-right">
          <!-- <b-form-checkbox
            v-if="lemma.trees"
            @change="saveLemmaTree"
            v-model="lemma.trees[0].checked"
            class="mb-4 d-inline-block"
            size="sm"
            name="check-button"
            switch
            :disabled="!$store.getters.checkRole('legam.dict.lemma.modify')"
          >
            Checked
          </b-form-checkbox> -->
          <span class="btn-legam-xs btn-legam-xxs ml-2" v-if="showClose" @click="closeLemmaDetails">
            <b-icon icon="x"></b-icon>
            Close
          </span>
          <button
            v-if="config.editable && $store.getters.checkRole('legam.dict.lemma.delete')"
            @click="deleteItem"
            class="btn-legam-xs mb-2 btn-danger"
          >
            <b-icon icon="trash2-fill"></b-icon>
            Delete lemma
          </button>
        </b-col>
      </b-row>
      <b-form-checkbox
        v-if="config.editable"
        v-model="lemma.isReconstructed"
        name="check-button"
        switch
        class="mt-4 mb-3"
        size="sm"
        @change="saveLemma"
        :disabled="!$store.getters.checkRole('legam.dict.lemma.modify')"
      >
        Is reconstructed
      </b-form-checkbox>

      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 class="text-left">
              {{ $t('Etymology') }}
              <span class="when-open float-right">-</span>
              <span class="when-closed float-right">+</span>
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion-1" role="tabpanel">
            <b-card-body>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1b class="text-left">
                      Lemma Links
                      <span class="when-open float-right">-</span>
                      <span class="when-closed float-right">+</span>
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-1b" accordion="my-accordion-1b" role="tabpanel">
                    <b-card-body>
                      <!-- <LemmaTable
                        :showTotal="false"
                        :lemmas="sense.lemmas"
                        @delete="deleteLemma"
                        :editMode="editMode"
                        v-if="sense.lemmas.length"
                      /> -->
                      <span
                        v-if="config.editable"
                        class="btn-legam-xs btn-legam-xxs ml-2 mb-2 float-right"
                        v-b-modal.modal-add-lemma
                      >
                        <b-icon icon="plus"></b-icon>
                        Add
                      </span>
                      <b-modal
                        v-if="config.editable"
                        id="modal-add-lemma"
                        title="Add lemma"
                        ok-only
                        ok-variant="secondary"
                        size="lg"
                      >
                        <LemmaAutocomplete @select="addLemma" :articleId="lemma.articleId"/>
                      </b-modal>
                      <LemmaTable
                        :lemmas="lemma.linkedLemmata"
                        :editMode="config.editable"
                        @delete="deleteLemma"
                      />
                      <!-- <span v-else>Loading...</span> -->
                    </b-card-body>
                  </b-collapse>
                </b-card>

              <LemmaEditEtymology
                :etymologies="lemma.etymologies"
                @update="updateEtymologies"
                :lemmaId="lemma.id"
                :disableEdit="!$store.getters.checkRole('legam.dict.lemma.modify') || !config.editable"
                id="etymology-modal"
              />

              <div v-if="etymologyMaterialsisEdit" class="occurrence-form edit-box-content">
                <b-form-group
                  id="etymology-group"
                >
                  <b-form-textarea
                    id="etymology-materials"
                    v-model="lemma.etymologyMaterials"
                    placeholder="Etymology Materials"
                    rows="6"
                    max-rows="6"
                    :style="this.etymologyMaterialsIsWellFormed ? '' : 'background-color: bisque;'"
                    @input="validateInput(lemma.etymologyMaterials)"
                  ></b-form-textarea>
                  <p
                    v-if="!this.etymologyMaterialsIsWellFormed"
                    style="font-style: italic;"
                  >XML mal-formed!</p>
                </b-form-group>
                <div class="float-right">
                  <div class="text-right" style="clear: both">
                    <button class="btn-legam-xs" @click="etymologyMaterialsisEdit = false">Close</button>
                    <button class="btn-legam-xs btn-legam-blue" @click="saveEtymologyMaterials" :disabled="!this.etymologyMaterialsIsWellFormed">Save</button>
                  </div>
                </div>
                <div style="clear: both"></div>
              </div>
              <div v-else class="occurrence-text">
                <p class="mb-2">
                  <span
                    class="btn-legam-xs btn-legam-xxs ml-2 float-right"
                    @click="etymologyMaterialsisEdit = true"
                    v-if="config.editable && $store.getters.checkRole('legam.dict.lemma.modify')"
                  >
                    <b-icon icon="pencil-fill"></b-icon>
                    Edit
                  </span>
                  <ExpandElement
                    :dataJson="expandEtymologyMaterials(lemma.etymologyMaterials)"
                    :defaultVisible="true"
                    id="display-etymologyMaterials"
                  />
                </p>
              </div>

            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-2 class="text-left">
              {{ $t('RedactedProtospellings') }}
              <span class="when-open float-right">-</span>
              <span class="when-closed float-right">+</span>
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion-2" role="tabpanel">
            <b-card-body>
              <LemmaEditProtospelling
                :lemma="lemma"
                :isDocLing="isDocLing"
                @showOccurrenceReferenceDetails="showOccurrenceReferenceDetails"
                @updateProtospellings="updateProtospellings"
                @addOccurrencesReferencesToProtospelling="addOccurrencesReferencesToProtospelling"
                @removeOccurrencesReferences="removeOccurrencesReferences"
                :disableEdit="!$store.getters.checkRole('legam.dict.lemma.modify') || !config.editable"
                :dictionaryId="dictionaryId"
                v-if="lemma.protospellings && lemma.tokens"
              />
              <div v-else>
                <b-container fluid="xxl">
                  <b-row class="justify-content-md-center">
                      <b-col class="mt-1">
                        <div class="spinner-border m-1" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </b-col>
                  </b-row>
                </b-container>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-3 class="text-left">
              {{ $t('Senses') }}
              <span class="when-open float-right">-</span>
              <span class="when-closed float-right">+</span>
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-3" accordion="my-accordion-3" role="tabpanel">
            <b-card-body>
              <LemmaEditSense
                :lemma="lemma"
                @showOccurrenceReferenceDetails="showOccurrenceReferenceDetails"
                @addOccurrencesReferencesToSense="addOccurrencesReferencesToSense"
                @removeOccurrencesReferences="removeOccurrencesReferences"
                @detachOccsRefs="detachOccsRefs"
                @newSenseTree="setNewSenseTree"
                @occurrenceSuppression="occurrenceSuppression"
                @referenceSuppression="referenceSuppression"
                :disableEdit="!$store.getters.checkRole('legam.dict.lemma.modify') || !config.editable"
                :dictionaryId="dictionaryId"
                v-if="lemma.senses && lemma.tokens"
              />
              <span v-else>Loading...</span>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <div v-if="config.editable">
        <hr>

        <b-form-group
          id="comment-group"
          label="Internal Comment:"
          label-for="comment"
        >
          <b-form-textarea
            id="comment"
            v-model="lemma.comment"
            placeholder="Internal Comment"
            rows="4"
            max-rows="4"
            @change="saveLemma"
            :disabled="!$store.getters.checkRole('legam.dict.lemma.modify')"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group
          id="public-comment-group"
          label="Supplementary Evidence:"
          label-for="public-comment"
        >
          <b-form-textarea
            id="public-comment"
            v-model="lemma.publicComment"
            placeholder="Supplementary Evidence"
            rows="4"
            max-rows="4"
            @change="saveLemma"
            :disabled="!$store.getters.checkRole('legam.dict.lemma.modify')"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group
          id="lemma-form-group"
          label="Lemma Form:"
          label-for="lemma-form"
        >
          <b-form-input
            id="lemma-form"
            v-model="lemma.lemmaForm"
            placeholder="Lemma Form"
            @change="saveLemma"
            :disabled="!$store.getters.checkRole('legam.dict.lemma.modify')"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          v-if="$store.getters.checkRole('legam.dict.lemma.modify') && !lemma.articleId"
          id="etymon-form-group"
          label="Etymon:"
          label-for="etymon-form"
        >
          <LemmaSelect
            :lemma="lemma.etymon"
            :isRequired=true
            @select="selectEtymon"
            v-model="lemma.etymon"
          />
        </b-form-group>

        <b-form-group
          id="part-of-speech-group"
          label="Part of speech:"
          label-for="part-of-speech"
        >
          <PartOfSpeechSelect
            :selected="lemma.partofspeeches"
            v-if="$store.getters.checkRole('legam.dict.lemma.modify')"
            @select="selectPartOfSpeech"
          />
          <span v-else-if="lemma.partofspeeches" class="text-bold">
            {{ lemma.partofspeeches.map(partofspeeche => partofspeeche.name).join(", ") }}
          </span>
        </b-form-group>

        <b-form-group
          id="language-group"
          label="Language:"
          label-for="language"
        >
          <LanguageSelect
            :language="lemma.language"
            @select="selectLanguage"
            v-if="$store.getters.checkRole('legam.dict.lemma.modify')"
          />
          <span v-else-if="lemma.language" v-html="lemma.language.name" class="text-bold"></span>
        </b-form-group>

        <b-form-group
          id="scripta-group"
          label="Scripta:"
          label-for="scripta"
        >
          <ScriptaSelect
            :languageCode="lemma.languageCode"
            :selected="lemma.scriptas"
            @select="selectScripta"
            v-if="$store.getters.checkRole('legam.dict.lemma.modify')"
          />
          <span v-else-if="lemma.scriptas" class="text-bold">
            {{ lemma.scriptas.map(scripta => scripta.name).join(", ") }}
          </span>
        </b-form-group>
      </div>
    </article>

    <b-modal :id="'modal-occurrence-details' + componentUUID" size="lg" ok-only ok-title="Close" title="Occurrence or reference details">
      <OccurrenceReferenceDetailsModal :occurrence_reference="occurrence_reference" />
    </b-modal>
  </div>
</template>

<style scoped>
  * >>> ul.occurrences-ul {
    list-style-type: '';
    padding-left: 0px;
  }

  * >>> .occurrences-ul .custom-checkbox,
  * >>> .occurrences-ul .custom-control-label {
    width: 100%;
  }

  li.occurrence {
    cursor: pointer;
  }

  .searchSense,
  .searchProtospelling {
    background-color: #f1f1f1;
    border-radius: 5px;
    padding: 15px 4px;
    margin-bottom: 20px;
  }

  * >>> cit {
    font-style: italic;
  }

  * >>> #display-etymologyMaterials {
    font-size: smaller;
  }

  #etymology-modal {
    margin-bottom: 30px;
  }

  * >>> .suppressedSign::before {
    content: "ø " / "supp.";
  }
  * >>> .suppressedSign {
    color: gray;
    font-weight: bold;
  }
</style>

<script>
  import Vue from 'vue'
  import router from '@/router'
  import { XMLStringIsWellFormed } from '@/utilities/xml-functions.js'

  import ExpandElement from '@/components/ExpandElement.vue'
  import LemmaAutocomplete from '@/components/Lemma/Autocomplete.vue'
  import LemmaEditEtymology from '@/components/Lemma/EditEtymology.vue'
  import LemmaEditProtospelling from '@/components/Lemma/EditProtospelling.vue'
  import LemmaEditSense from '@/components/Lemma/EditSense.vue'
  import LemmaSelect from '@/components/Lemma/LemmaSelect.vue'
  import LemmaTable from '@/components/Lemma/Table.vue'
  import OccurrenceReferenceDetailsModal from '@/components/Lemma/OccurrenceReferenceDetailsModal.vue'

  import PartOfSpeechSelect from '@/components/Dictionary/PartOfSpeechSelect.vue'
  import ScriptaSelect from '@/components/Main/ScriptaSelect.vue'
  import LanguageSelect from '@/components/Main/LanguageSelect.vue'
  import config from '@/config.js'


  export default {
    name: 'LemmaEditDetails',
    props: ['lemmaId', 'lemmaObj', 'showCloseButton', 'dictionaryId', 'hideTitle'],
    components: {
      ExpandElement,
      LemmaAutocomplete,
      LemmaEditEtymology,
      LemmaEditProtospelling,
      LemmaEditSense,
      OccurrenceReferenceDetailsModal,
      PartOfSpeechSelect,
      ScriptaSelect,
      LanguageSelect,
      LemmaSelect,
      LemmaTable
    },
    data(){
      let _lemma = this.lemmaObj
      if (_lemma && !_lemma.protospellingTree){
        _lemma.protospellingTree = {id: null, children: []}
      }
      return {
        lemma: _lemma,
        loading: true,
        showSenseBox: {},
        showProtospellingBox: {},
        showClose: (this.showCloseButton || this.showCloseButton === undefined ? true : false),
        occurrence_reference: null,
        componentUUID: this.$store.getters.getUUID(),
        config: config,
        etymologyMaterialsisEdit: false,
        etymologyMaterialsIsWellFormed: true,
      }
    },
    computed: {
      lemmaDisplay(){
        let retval = ''
        if (this.lemma){
          let prefix = ''
          if (this.lemma.scriptas.length){
            prefix = `<small>${this.lemma.scriptas.map(scripta => scripta.code).join(', ')} </small>`
          }
          if (this.lemma.isReconstructed){
            prefix = `${prefix}*`
          }
          let sufix = ''
          if (this.lemma.partofspeeches.length){
            sufix = `<small> ${this.lemma.partofspeeches.map(partofspeeche => partofspeeche.name).join(', ')}</small>`
          }
          let etymon = ''
          if (this.lemma.treeParent){
            etymon = `<small> [${this.lemma.treeParent.display}]</small>`
          }
          if (this.lemma.etymon){
            etymon = `<small> [${this.lemma.etymon.display}]</small>`
          }
          retval = `${prefix}${this.lemma.lemmaForm}${sufix}${etymon}`
        }
        return retval
      },
      isDocLing(){
        return (this.lemma
          && this.lemma.articleDictionaryAcronym
          && this.lemma.articleDictionaryAcronym.toLowerCase().substring(0, 7) == "docling") ? true : false
      }
    },
    mounted(){
      if (!this.lemma){
        this.loadLemma()
      }
      else {
        // this.checkSpellingsSenses()
        this.loadLemmaTokens()
        this.loading = false
      }
    },
    watch: {
      'lemmaId'(){
        this.loading = true
        this.loadLemma()
      },
      'lemma'(){
        this.loading = false
        if (this.lemma && !this.lemma.protospellingTree){
          this.lemma.protospellingTree = {id: null, children: []}
        }
      }
    },
    methods: {
      occurrenceSuppression(occType, id, toSuppress, entityType) {
        const occIdx = this.lemma.occurrences.findIndex(x => x[`${occType}Id`] == id)
        const occ    = this.lemma.occurrences[occIdx]
        const prop   = entityType === "sense" ? "suppressedSenseDictionaries" : "suppressedSpellingDictionaries"

        if (toSuppress) {
          if (!occ[occType][prop].map(x => x.id).includes(this.lemma.articleDictionaryId)) {
            occ[occType][prop].push({id: this.lemma.articleDictionaryId})
          }
        } else {
          occ[occType][prop] = occ[occType][prop].filter(x => x.id !== this.lemma.articleDictionaryId)
        }

        Vue.set(this.lemma, 'occurrences', this.lemma.occurrences.slice(0, occIdx).concat(occ).concat(this.lemma.occurrences.slice(occIdx + 1)))

        Object.values(this.lemma.senses).forEach(sense => {
          Vue.set(sense, '_details', false)
        })
      },
      referenceSuppression(id, toSuppress, entityType) {
        const refIdx = this.lemma.references.findIndex(x => x.id === id)
        const ref    = this.lemma.references[refIdx]
        const prop   = entityType === "sense" ? "suppressedSenseDictionaries" : "suppressedSpellingDictionaries"

        if (toSuppress) {
          if (!ref[prop].map(x => x.id).includes(this.lemma.articleDictionaryId)) {
            ref[prop].push({id: this.lemma.articleDictionaryId})
          }
        } else {
          ref[prop] = ref[prop].filter(x => x.id !== this.lemma.articleDictionaryId)
        }

        Vue.set(this.lemma, 'references', this.lemma.references.slice(0, refIdx).concat(ref).concat(this.lemma.references.slice(refIdx + 1)))

        Object.values(this.lemma.senses).forEach(sense => {
          Vue.set(sense, '_details', false)
        })
      },
      setNewSenseTree(tree) {
        this.lemma.senseTree = tree
      },
      saveEtymologyMaterials() {
        this.saveLemma()
        this.etymologyMaterialsisEdit = false
      },
      validateInput(string) {
        if (string.trim() == '') {
          this.etymologyMaterialsIsWellFormed = true
        } else {
          XMLStringIsWellFormed(string) ? this.etymologyMaterialsIsWellFormed = true : this.etymologyMaterialsIsWellFormed = false
        }
      },
      expandEtymologyMaterials(string) {
        return {
          title: `[${this.$t('EtymologyMaterials')}]`,
          isDeafplus: false,
          isSafe: true,
          text: string,
        }
      },
      getLemmaId(){
        return this.lemma ? this.lemma.id : this.lemmaId
      },
      addLemma(lemma) {
        this.$bvModal.hide('modal-add-lemma')
        this.lemma.linkedLemmata.push(lemma)
        this.saveLemma()
      },
      deleteLemma(lemmaId) {
        this.lemma.linkedLemmata = this.lemma.linkedLemmata.filter(lemma => lemma.id != lemmaId)
        this.saveLemma()
      },
      loadLemmaTokens(){
        if (config.editable || this.lemma.tokenCount > 0) {
          this.$store.dispatch('loadLemmaTokens', this.getLemmaId()).then((tokens) => {
            this.lemma['tokens'] = tokens['tokens']
            this.$forceUpdate()
          }).catch(error => {
            this.lemma['tokens'] = []
            this.$store.dispatch('addNotification', {
              type: 'danger',
              text: error.message || 'Lemma tokens could not be loaded',
            })
            this.$forceUpdate()
          })
        }
        else {
          this.lemma['tokens'] = []
        }
      },
      loadLemma(){
        this.$store.dispatch('loadLemma', this.lemmaId).then((lemma) => {
          this.lemma = lemma
          this.loadLemmaTokens()
        })
      },
      deleteItem(){
        if (this.lemma.articleId){
          this.$store.dispatch('addNotification', {
            type: 'warning',
            text: `First remove lemma from article`
          })
        }
        else {
          this.$bvModal.msgBoxConfirm('Are you sure?').then(value => {
            if (value){
              this.$store.dispatch('deleteLemma', this.getLemmaId()).then(() => {
                router.push(`/lemmas`)
              })
            }
          })
        }
      },
      showOccurrenceReferenceDetails(occurrence_reference){
        this.occurrence_reference = occurrence_reference
        this.$bvModal.show(`modal-occurrence-details${this.componentUUID}`)
      },
      saveLemma(){
        this.$store.dispatch('saveLemma', this.lemma).then(() => {
          this.$emit('update')
        })
      },
      selectPartOfSpeech(partofspeeches){
        this.lemma['partofspeeches'] = partofspeeches
        this.saveLemma()
      },
      selectScripta(scriptas){
        this.lemma['scriptas'] = scriptas
        this.saveLemma()
      },
      selectLanguage(language){
        this.lemma.languageCode = null
        this.lemma.language = null
        if (language){
          this.lemma.languageCode = language.code
          this.lemma.language = language
        }
        this.saveLemma()
      },
      selectEtymon(lemma){
        if (lemma){
          this.lemma.etymon = lemma
        } else {
          this.lemma.etymon = null
        }
        this.saveLemma()
      },
      saveLemmaTree(){
        this.$store.dispatch('saveLemmaTree', this.lemma)
      },
      detachOccsRefs(toDeleteArray, purgeSwitch) {
        this.$store.dispatch('detachOccsRefs', {
          lemmaId: this.lemma.id,
          toDelete: toDeleteArray,
          purgeSwitch: purgeSwitch
        }).then(() => {
          toDeleteArray.forEach(([id, type]) => {
            if (type == 'containerOccurrence') {
              this.lemma.occurrences = this.lemma.occurrences.filter(x => x.containerOccurrenceId !== id)
            } else if (type == 'occurrence') {
              this.lemma.occurrences = this.lemma.occurrences.filter(x => x.occurrenceId !== id)
            } else if (type == 'reference') {
              this.lemma.references = this.lemma.references.filter(x => x.id !== id)
            }
          })

          this.$store.dispatch('addNotification', {
            type: 'success',
            text: 'Occurrences/References detached from lemma'
          })
          this.$forceUpdate()
        })
      },
      removeOccurrencesReferences(occurrences_references, selectedLemma){
        let selectedOccurrences = occurrences_references.map(occurrence_reference_id => {
          let type = (occurrence_reference_id in this.lemma.referencesDictIndex ? 'reference' : 'occurrence')
          return [occurrence_reference_id, type]
        })

        this.$store.dispatch('moveOccurrencesReferenceToLemma', {
          lemmaId: selectedLemma.id,
          occurrencesReferences: selectedOccurrences
        }).then(() => {
          Vue.set(this.lemma, 'occurrences', this.lemma.occurrences.filter(occurrence => !occurrences_references.includes(occurrence.occurrenceId)))
          Vue.set(this.lemma, 'occurrences', this.lemma.occurrences.filter(occurrence => !occurrences_references.includes(occurrence.containerOccurrenceId)))
          Vue.set(this.lemma, 'references', this.lemma.references.filter(reference => !occurrences_references.includes(reference.id)))
        })
      },
      async addOccurrencesReferencesToSense(occurrences_references, sense){
        await this.$store.dispatch('loadSense', {
          senseId: sense.lemmaSense.id,
          lemmaId: this.lemma.id
        }).then(async (_sense) => {
          sense = _sense

          sense.lemmaSense.occurrences          = []
          sense.lemmaSense.containerOccurrences = []
          sense.lemmaSense.references           = []

          if (!Object.keys(this.lemma.senses).includes(sense.lemmaSense.id)) {
            Vue.set(this.lemma.senses, [sense.lemmaSense.id], sense)

            if (!this.lemma.senseTree){
              this.lemma.senseTree = {id: null, children: []}
            }
            this.lemma.senseTree.children = [...this.lemma.senseTree.children, {id: sense.lemmaSense.id, children: []}]
          }
        })

        for (let occurrence_reference_id of occurrences_references){
          if (occurrence_reference_id in this.lemma.occurrencesDictIndex){
            let occurrenceIndex = this.lemma.occurrencesDictIndex[occurrence_reference_id]
            let occurrence = this.lemma.occurrences[occurrenceIndex]
            this._connectOccurrenceToSense(sense, occurrence.occurrence)
          }
          else if (occurrence_reference_id in this.lemma.containerOccurrencesDictIndex){
            let occurrenceIndex = this.lemma.containerOccurrencesDictIndex[occurrence_reference_id]
            let occurrence = this.lemma.occurrences[occurrenceIndex]
            this._connectOccurrenceToSense(sense, occurrence.containerOccurrence)
          }
          else {
            let referenceIndex = this.lemma.referencesDictIndex[occurrence_reference_id]
            let reference = this.lemma.references[referenceIndex]
            this._connectReferenceToSense(sense, reference)
          }
        }
        this.$store.dispatch('addNotification', {
          type: 'success',
          text: `Occurrences/References added`
        })
      },
      _connectReferenceToSense(sense, reference){
        this.$store.dispatch('addReferenceToSPS', {
          lemmaId: this.lemma.id,
          referenceId: reference.id,
          senseId: sense.lemmaSense.id
        }).then(() => {
          this.lemma.senses[sense.lemmaSense.id].lemmaSense.references.push(reference)
          reference.lemmaSense = [{id: sense.lemmaSense.id}]
        })
      },
      _connectOccurrenceToSense(sense, occurrence){
        // Connect occurrence to PS
        this.$store.dispatch('addOccurrenceToSPS', {
          lemmaId: this.lemma.id,
          occurrenceId: occurrence.id,
          lemmaSenseId: sense.lemmaSense.id
        }).then(() => {
          if (occurrence._occurrenceType == 'containeroccurrence'){
            this.lemma.senses[sense.lemmaSense.id].lemmaSense.containerOccurrences.push(occurrence)
          }
          else {
            // occurrences
            this.lemma.senses[sense.lemmaSense.id].lemmaSense.occurrences.push(occurrence)
          }
          occurrence.lemmaSenseId = sense.lemmaSense.id

          this.showSenseBox[occurrence.id] = false
          // Use a :key for the component and reset the key for update data
          // this.index++
        })
      },
      updateEtymologies(etymologies){
        this.lemma.etymologies = etymologies
      },
      async addOccurrencesReferencesToProtospelling(occurrences_references, protospellingId){
        if (!(protospellingId in this.lemma.protospellings)){
          await this.$store.dispatch('loadProtospelling', {
            protospellingId: protospellingId,
            lemmaId: this.lemma.id
          }).then(async (_protospelling) => {
            if (!_protospelling.lemmaProtospelling){
              _protospelling.lemmaProtospelling = {
                checked: false,
                isLeftValid: null,
                isRightValid: null,
                leftContext: '',
                lemmaId: this.lemma.id,
                linguisticSpecification: '',
                protospellingId: protospellingId,
                rightContext: '',
              }
              if (!('occurrencesSurfaceFormGrouped' in _protospelling)){
                _protospelling['occurrencesSurfaceFormGrouped'] = {}
              }

              await this.$store.dispatch('addProtospellingToLemma', {
                lemmaId: this.lemma.id,
                protospellingId: protospellingId,
              }).then(() => {
                this.lemma.protospellings[protospellingId] = _protospelling
                if (!this.lemma.protospellingTree){
                  this.lemma.protospellingTree = {id: null, children: []}
                }
                this.lemma.protospellingTree.children.push({id: protospellingId, children: []})
              })
            }
            else if (!(protospellingId in this.lemma.protospellings)){
              this.lemma.protospellings[protospellingId] = _protospelling
              if (!this.lemma.protospellingTree){
                this.lemma.protospellingTree = {id: null, children: []}
              }
              this.lemma.protospellingTree.children.push({id: protospellingId, children: []})
            }
          })
        }

        for (let occurrence_reference_id of occurrences_references){
          if (occurrence_reference_id in this.lemma.occurrencesDictIndex){
            let occurrenceIndex = this.lemma.occurrencesDictIndex[occurrence_reference_id]
            let occurrence = this.lemma.occurrences[occurrenceIndex]
            this._connectOccurrenceToProtospelling(protospellingId, occurrence.occurrence)
          }
          else if (occurrence_reference_id in this.lemma.containerOccurrencesDictIndex){
            let occurrenceIndex = this.lemma.containerOccurrencesDictIndex[occurrence_reference_id]
            let occurrence = this.lemma.occurrences[occurrenceIndex]
            this._connectOccurrenceToProtospelling(protospellingId, occurrence.containerOccurrence)
          }
          else {
            let referenceIndex = this.lemma.referencesDictIndex[occurrence_reference_id]
            let reference = this.lemma.references[referenceIndex]
            this._connectReferenceToProtospelling(protospellingId, reference)
          }
        }
        this.$store.dispatch('addNotification', {
          type: 'success',
          text: `Occurrences/References added`
        })
      },
      _connectReferenceToProtospelling(protospellingId, reference){
        this.$store.dispatch('addReferenceToSPS', {
          lemmaId: this.lemma.id,
          referenceId: reference.id,
          protospellingId: protospellingId
        }).then(() => {
          this.lemma.protospellings[protospellingId].references.push(reference)
          reference.protospellingIds.push(protospellingId)
          if (reference.surfaceForm){
            let surfaceFormKey = reference.surfaceForm
            if (!(surfaceFormKey in this.lemma.protospellings[protospellingId].occurrencesSurfaceFormGrouped)){
              this.lemma.protospellings[protospellingId].occurrencesSurfaceFormGrouped[surfaceFormKey] = []
            }
            this.lemma.protospellings[protospellingId].occurrencesSurfaceFormGrouped[surfaceFormKey].push(
              [reference.id, 'reference']
            )
          }
        })
      },
      _connectOccurrenceToProtospelling(protospellingId, occurrence){
        // Connect occurrence to PS
        this.$store.dispatch('addOccurrenceToSPS', {
          lemmaId: this.lemma.id,
          occurrenceId: occurrence.id,
          protospellingId: protospellingId
        }).then(() => {
          this.lemma.protospellings[protospellingId] = {
            'occurrences': [],
            'containerOccurrences': [],
            'occurrencesSurfaceFormGrouped': {},
            ...this.lemma.protospellings[protospellingId]
          }
          occurrence.protospellingId = protospellingId

          if (occurrence._occurrenceType == 'containeroccurrence'){
            this.lemma.protospellings[protospellingId].containerOccurrences.push(occurrence)
          }
          else {
            // occurrences
            this.lemma.protospellings[protospellingId].occurrences.push(occurrence)
          }
          let surfaceFormKey = null
          if (occurrence.externalEvidence && occurrence.externalEvidence.surfaceForm){
            surfaceFormKey = occurrence.externalEvidence.surfaceForm
          }
          else if (occurrence.token){
            surfaceFormKey = occurrence.token.form
          }
          if (surfaceFormKey){
            if (!this.lemma.protospellings[protospellingId].occurrencesSurfaceFormGrouped[surfaceFormKey]){
              this.lemma.protospellings[protospellingId].occurrencesSurfaceFormGrouped[surfaceFormKey] = []
            }
            this.lemma.protospellings[protospellingId].occurrencesSurfaceFormGrouped[surfaceFormKey].push(
              [occurrence.id, occurrence._occurrenceType]
            )
          }
          this.showProtospellingBox[occurrence.id] = false
          // Use a :key for the component and reset the key for update data
          // this.index++
        })
      },
      showAddSenseBox(occurrenceId){
        Vue.set(this.showSenseBox, occurrenceId, true)
      },
      showAddProtospellingBox(occurrenceId){
        Vue.set(this.showProtospellingBox, occurrenceId, true)
      },
      closeLemmaDetails(){
        this.$emit('close')
      },
      updateProtospellings(protospellings, protospellingTree){
        this.lemma.protospellings = protospellings
        this.lemma.protospellingTree = protospellingTree
      }
    }
  }
</script>
